"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ContinueInDealershipMessage_1 = require("./continueInDealership/ContinueInDealershipMessage");
var ConfirmationMainContent_1 = require("./confirmationMainContent/ConfirmationMainContent");
var JourneyTypes_1 = require("../../../../../../common/enum/JourneyTypes");
var cache_1 = require("../../../common/graphql/cache");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var ConfirmationScreenDataLayerHandler_1 = require("../../../common/utils/dataLayer/ConfirmationScreenDataLayerHandler");
var useWidgetContext_1 = require("../../../../common/react/useWidgetContext");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var ContinueInDealerConfirmationScreen = function () {
    var dimensions = useWidgetContext_1.default().configuration.dimensions;
    var _a = usePlatformConfig_1.default().platformConfig.priceDisplay.primary, subunitToUnit = _a.subunitToUnit, decimalScale = _a.decimalScale;
    react_1.useEffect(function () {
        cache_1.activeJourneyType(JourneyTypes_1.JourneyTypes.CONTINUE_IN_DEALERSHIP);
    }, []);
    var deal = useCheckoutContext_1.default().deal;
    react_1.useEffect(function () {
        if (deal) {
            ConfirmationScreenDataLayerHandler_1.default({ deal: deal, dimensions: dimensions, subunitToUnit: subunitToUnit, decimalScale: decimalScale });
        }
    }, [deal]);
    return (<>
      <ConfirmationMainContent_1.default>
        <ContinueInDealershipMessage_1.default />
      </ConfirmationMainContent_1.default>
    </>);
};
exports.default = ContinueInDealerConfirmationScreen;
